import { useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { CssBaseline } from "@mui/material";
import PerfectScrollBar from "react-perfect-scrollbar";

import Lion from "../assets/auth images/lion.png";
import GlobalStyle from "../components/GlobalStyle";
import { renderUserInterface } from "../redux/slices/renderUISlice";

// Root wrapper
const Root = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
`;

// Scrollable right side
const ScrollBar = styled(PerfectScrollBar)`
  height: 100%;
  overflow: hidden;
  width: 40%;

  @media (max-width: 1100px) {
    width: 100%;
  }

  @media (max-width: 850px) {
    width: 100%;
  }
`;

// Right panel content container
const MainDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 850px) {
    padding: 20px;
    margin: 0;
  }

  @media (max-width: 1100px) {
    padding: 20px;
    margin: 0;
  }
`;

export default function AuthLayout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(renderUserInterface());
  }, [dispatch]);

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />

      <div className="left-section">
        <div className="logo-section">
          <div className="sun-logo">
            <img style={{}} src={Lion} alt="lion" />
          </div>
        </div>

        <div className="marketing-content">
          <h1 className="main-heading">Uncover. Understand. Activate</h1>
          <p className="tagline">Where data meets precision targeting</p>
        </div>
      </div>

      <ScrollBar>
        <MainDiv>
          <Outlet />
        </MainDiv>
      </ScrollBar>
    </Root>
  );
}
